import React from 'react'
import decodeHtml from '../../functions/decodeHtml'
import config from '../../config.json'
import Translation from '../Translation/cont/Translation'
import MovieURL from '../../containers/general/MovieURL'

const movieAttributesNames = config.movieAttributesTransIds


const MovieInformationItem = ({infoKey, valueDisplay}) => (
    <div className="movie-information-item">
        <span className="movie-information-item-name text-small-light"><Translation id={movieAttributesNames[infoKey]} />:</span>
        <span className="movie-information-item-value text-small-regular"> {valueDisplay}</span>
    </div>
)

const MovieInformation = ({movieData, keysToDisplay}) => (
    <div className="movie-information">
        {keysToDisplay.map((key, index) => (
            (movieData[key] || key === 'url' || key === 'fsk') ? (
                'actors' === key ? (
                    <MovieInformationItem
                        key={index}
                        infoKey={key}
                        valueDisplay={decodeHtml(movieData[key].map((actor, index) => (0 === index ? '': ' ') + actor.name))}
                    />
                ) : 'directors' === key ? (
                    <MovieInformationItem
                        key={index}
                        infoKey={key}
                        valueDisplay={movieData[key].map((director, index) => (0 === index ? '': ' ') + director.name)}
                    />
                ) : "origTitle" === key ? (
                    <MovieInformationItem
                        key={index}
                        infoKey={key}
                        valueDisplay={decodeHtml(movieData[key])}
                    />
                ) : 'url' === key ? (
                    <MovieURL
                        key={index}
                        movieId={movieData.id}
                    />
                ) : Array.isArray(movieData[key]) ? (
                    <MovieInformationItem
                        key={index}
                        infoKey={key}
                        valueDisplay={movieData[key].join(', ')}
                    />
                ) : (key === "fsk" && movieData[key] === -1) ? (
                    <MovieInformationItem
                        key={index}
                        infoKey={key}
                        valueDisplay='noch nicht bekannt'
                    />
                ) : (
                    <MovieInformationItem
                        key={index}
                        infoKey={key}
                        valueDisplay={movieData[key]}
                    />
                )
            ) : ('')
        ))}
    </div>
)


export default MovieInformation